module.exports = __webpack_public_path__ + "static/media/Gold-jewelry.8f9a7e66.jpg";